import { Flex, Icon, Text, Tooltip } from '@chakra-ui/react'
import React, { Key, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import iconDoubleLeftArrow from '~/assets/svgs/icon-double-left-arrow.svg?react'
import iconDoubleRightArrow from '~/assets/svgs/icon-double-right-arrow.svg?react'
import iconGear from '~/assets/svgs/icon-gear.svg?react'
import {
  SiteNavigationCollapseTabSizes,
  useSiteNavigationCollapseTabStyle,
} from '~/pages/Home/SiteNavigation/componentStyles/SiteNavigationCollapseTab.style'

interface SiteNavigationCollapseTabProps {
  id?: Key | undefined
  isCollapsed?: boolean
  isSelected?: boolean
  hideExpand?: boolean
  onCollapseClicked?: () => void
  onExpandClicked?: () => void
  onSettingsClicked?: (id?: Key | undefined) => void
}
export const SiteNavigationCollapseTab = ({
  id,
  isCollapsed,
  isSelected,
  hideExpand,
  onCollapseClicked,
  onExpandClicked,
  onSettingsClicked,
}: SiteNavigationCollapseTabProps) => {
  const { t } = useTranslation()
  const styles = useSiteNavigationCollapseTabStyle({
    size: isCollapsed
      ? SiteNavigationCollapseTabSizes.Collapsed
      : SiteNavigationCollapseTabSizes.Normal,
  })

  const collapseTabContent = useMemo(() => {
    if (!isCollapsed) {
      return (
        <>
          <Flex
            sx={styles.contentWrapper}
            className="collapse-tab-content"
            onClick={onCollapseClicked}
          >
            <Flex sx={styles.arrowIconWrapper}>
              <Icon as={iconDoubleLeftArrow} sx={styles.arrowIcon} />
            </Flex>
            <Text sx={styles.text}>{t('baseSettings.collapse')}</Text>
          </Flex>
          <Tooltip hasArrow label={t('nav.settings')} placement="right">
            <Flex
              onClick={() => onSettingsClicked?.(id)}
              sx={styles.settingsIconWrapper}
              aria-selected={isSelected}
            >
              <Icon
                as={iconGear}
                sx={styles.settingsIcon}
                className="collapse-tab-settings-icon"
              />
            </Flex>
          </Tooltip>
        </>
      )
    }

    return (
      <>
        <Tooltip hasArrow label={t('nav.settings')} placement="right">
          <Flex
            onClick={() => onSettingsClicked?.(id)}
            sx={styles.settingsIconWrapper}
            aria-selected={isSelected}
          >
            <Icon
              as={iconGear}
              sx={styles.settingsIcon}
              className="collapse-tab-settings-icon"
            />
          </Flex>
        </Tooltip>
        {!hideExpand && (
          <Tooltip hasArrow label={t('baseSettings.expand')} placement="right">
            <Flex sx={styles.arrowIconWrapper} onClick={onExpandClicked}>
              <Icon
                as={iconDoubleRightArrow}
                className="collapse-tab-arrow-icon"
                sx={styles.arrowIcon}
              />
            </Flex>
          </Tooltip>
        )}
      </>
    )
  }, [
    isCollapsed,
    hideExpand,
    onCollapseClicked,
    onExpandClicked,
    onSettingsClicked,
    t,
  ])

  return (
    <Flex sx={styles.container} key={id}>
      {collapseTabContent}
    </Flex>
  )
}
